import axios, { AxiosInstance } from "axios";
import store from "@/store";
import { AuthModule } from "@/store";

const service = axios.create({
  baseURL: process.env.VUE_APP_INSTANCE_URL,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
  responseType: "json",
  timeout: parseInt(process.env.VUE_APP_HTTP_REQUEST_TIMEOUT as string) || 5000,
});

service.interceptors.response.use(
  response => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  error => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response && error.response.status === 401) {
      AuthModule.store.logout();
    }
    return Promise.reject(error);
  },
);

export default {
  get instance(): AxiosInstance {
    return service;
  },

  get<T = any>(path: string, data: object | null = null) {
    return this.request<T>("get", path, data);
  },

  post<T = any>(path: string, data: object | null = null, onUploadProgress?: any) {
    return this.request<T>("post", path, data, onUploadProgress);
  },

  delete<T = any>(path: string, data: object | null = null) {
    return this.request<T>("delete", path, data);
  },

  put<T = any>(path: string, data: object | null = null, onUploadProgress?: any) {
    return this.request<T>("put", path, data, onUploadProgress);
  },

  request<T = any>(method: any, url: string, payload: { [Keys: string]: any } | null, onUploadProgress?: any) {
    let data = null;
    const token = (store.state as any).auth.token;
    let headers = {};

    let cancelToken;

    if (payload && typeof payload === "object") {
      if ("_cancelToken" in payload) {
        cancelToken = payload._cancelToken;
        delete payload._cancelToken;
      }

      data = JSON.stringify(payload);
    }

    if (token !== null) {
      headers = {
        authorization: token,
      };
    }

    return service
      .request<T>({
        method,
        url,
        data,
        cancelToken,
        headers,
        onUploadProgress,
      })
      .then(resp => resp.data)
      .catch(error => {
        if (error.response && error.response.data && error.response.data.error) {
          throw new Error(error.response.data.error);
        } else if (error.response && error.response.data && error.response.data.message) {
          throw new Error(error.response.data.message);
        } else {
          throw new Error("Errore imprevisto, non è stato possibile completare l'operazione. Riprova più tardi!");
        }
      });
  },

  download<T = any>(url: string) {
    const token = (store.state as any).auth.token;
    let headers = {};

    if (token !== null) {
      headers = {
        authorization: token,
      };
    }

    return service.request<T>({
      method: "get",
      url,
      headers,
      responseType: "blob",
    });
  },

  downloadPost<T = any>(url: string, body: any) {
    const token = (store.state as any).auth.token;
    let headers = {};

    if (token !== null) {
      headers = {
        authorization: token,
      };
    }

    return service.request<T>({
      method: "post",
      url,
      headers,
      data: body,
      responseType: "blob",
    });
  },
};
